import 'vuetify/src/stylus/app.styl';
import { Scroll } from 'vuetify/es5/directives';
import {
	Vuetify,
	VAlert,
	VApp,
	VBtn,
	VBtnToggle,
	VCard,
	VCheckbox,
	VChip,
	VDataIterator,
	VDatePicker,
	VDialog,
	VDivider,
	VForm,
	VGrid,
	VIcon,
	VList,
	VMenu,
	VNavigationDrawer,
	VRadioGroup,
	VSelect,
	VSlider,
	VSnackbar,
	VSubheader,
	VTextField,
	VTimePicker,
	VToolbar,
	VTooltip,
	transitions,
	VExpansionPanel,
	VDataTable,
	VProgressLinear,
	VTabs,
	VStepper,
	VSwitch,
	VProgressCircular,
	VPagination,
} from 'vuetify';

export default function (Vue) {
	Vue.use(
		Vuetify,
		{
			components: {
				VAlert,
				VApp,
				VBtn,
				VBtnToggle,
				VCheckbox,
				VChip,
				VCard,
				VDataIterator,
				VDatePicker,
				VDialog,
				VDivider,
				VForm,
				VGrid,
				VIcon,
				VList,
				VMenu,
				VNavigationDrawer,
				VRadioGroup,
				VSelect,
				VSlider,
				VSnackbar,
				VSubheader,
				VTextField,
				VTimePicker,
				VToolbar,
				VTooltip,
				transitions,
				VExpansionPanel,
				VDataTable,
				VProgressLinear,
				VTabs,
				VStepper,
				VSwitch,
				VProgressCircular,
				VPagination,
			},
			theme: {
				accent: '#828282',
				background: '#f6fbff',
				border: 'cce8ff',
				darkenprimary: '#007e81',
				error: '#FF5253',
				info: '#8dcdd0',
				primary: '#02979b',
				secondary: '#085f65',
				success: '#b1dc03',
				warning: '#02979b',
				newaccent: '#8f8f8f',
				newbackground: '#f2f6f7',
				newborder: '#e4e4e4',
				newinfo: '#a6a6a6',
				newprimary: '#ff6e1c',
				newsecondary: '#4a4a4a',
				newwarning: '#494949',
				orange: '#ff5c00',
				succesL: '#b0ca20',
				backL: '#20b1ca',
				backGeoL: '#e9f8fb',
			},
			directives: {
				Scroll,
			},
		},
	);
}



// WEBPACK FOOTER //
// ./src/vuetify.js